import React, { useState } from "react";
import "./style.less";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../InputText/InputText";
import Button from "../Button/Button";
import upload from "../../images/careers/upload.svg";
import moment from "moment";
import axios from "axios";
import urldata from "../../urldata";

const JobApplyModel = (props) => {
  const [name, setName] = useState("");
  const [nameerr, setNameerr] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumbererr, setPhoneNumbererr] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailIderr, setEmailIderr] = useState("");
  const [qualification, setQualification] = useState("");
  const [qualificationerr, setQualificationErr] = useState("");
  const [experience, setExperience] = useState("");
  const [experienceerr, setExperienceErr] = useState("");
  const [messageerr, setMessageErr] = useState("");
  const [resume, setResume] = useState("");
  const [resumeerr, setResumeErr] = useState("");

  const hasExtension = (inputID, exts) => {
    var fileName = document.getElementById(inputID).value;
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName
    );
  };

  const submit = () => {
    //console.log(name, emailId, experience, phoneNumber, resume, qualification);
    var formIsValid = true;

    if (!name) {
      formIsValid = false;
      setNameerr("*Please enter your name.");
    } else {
      setNameerr("");
    }

    if (typeof name !== "undefined") {
      if (!name.match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        setNameerr("*Please enter alphabet characters only.");
      }
    }

    if (typeof emailId !== "undefined") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(emailId)) {
        formIsValid = false;
        setEmailIderr("*Please enter valid email-Id.");
      } else {
        setEmailIderr("");
      }
    }

    if (typeof phoneNumber !== "undefined") {
      if (!phoneNumber.match(/^[0-9]{10}$/)) {
        formIsValid = false;
        setPhoneNumbererr("*Please enter valid mobile no.");
      } else {
        setPhoneNumbererr("");
      }
    }
    if (!qualification) {
      formIsValid = false;
      setQualificationErr("*Please enter your qualifaication.");
    } else {
      setQualificationErr("");
    }
    if (!experience) {
      formIsValid = false;
      setExperienceErr("*Please enter your experience.");
    } else {
      setExperienceErr("");
    }

    if (!resume) {
      formIsValid = false;
      setResumeErr("*Please upload your resume.");
    } else {
      setResumeErr("");
    }
    if (resume) {
      var FileSize = resume.size / 1024 / 1024;
      if (FileSize > 2) {
        formIsValid = false;
        setResumeErr("File size exceeds 2 MiB");
      }
    }

    if (!hasExtension("uploadResume2", [".jpg", ".pdf", ".doc", ".docx"])) {
      setResumeErr("Please Select Valid Format");
      formIsValid = false;
    }

    if (formIsValid) {
      //console.log(props.id);

      let data = {};
      data.postApplyFor = props.designation;
      data.name = name;
      data.emailId = emailId;
      data.phoneNumber = phoneNumber;
      data.qualifications = qualification;
      data.experience = experience;
      data.postId = props.id;
      data.date = moment().format("DD-MM-YYYY");
      data.time = moment().format("hh:mm a");

      console.log(data);

      let url = new URL(urldata + "user/applyJob");
      Object.keys(data).forEach((key) =>
        url.searchParams.append(key, data[key])
      );
      var decoded = decodeURIComponent(url);

      var formData = new FormData();
      formData.append("resume", resume);

      axios({
        method: "post",
        url: decoded,
        data: formData,
        crossDomain: true,
        withCredentials: true,
      })
        .then((response) => {
          document.getElementById("uploadResume2").value = "";
          setResume("");
          setEmailId("");
          setPhoneNumber("");
          setQualification("");
          setExperience("");
          setName("");
          props.showToast("success");
          props.onHide();
        })
        .catch((error) => {
          alert("Something Went Wrong");
        });
    }
  };

  return (
    <Modal
      {...props}
      //   size="lg"
      //   aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="jobApplyModel"
      centered
    >
      <Modal.Body className="model">
        <div className="title">APPLY FOR THE JOB</div>
        <Row>
          <Col lg={6}>
            <InputText value={props.designation} title="Post Applied For*" />
          </Col>
          <Col lg={6}>
            <InputText
              value={name}
              onChange={(e) => setName(e.target.value)}
              title="Name*"
            />
            <div className="err">{nameerr}</div>
          </Col>
          <Col lg={6}>
            <InputText
              value={emailId}
              onChange={(e) => setEmailId(e.target.value)}
              title="Email ID*"
            />
            <div className="err">{emailIderr}</div>
          </Col>
          <Col lg={6}>
            <InputText
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              title="Phone Number*"
            />
            <div className="err">{phoneNumbererr}</div>
          </Col>
          <Col lg={6}>
            <InputText
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
              title="Qualification*"
            />
            <div className="err">{qualificationerr}</div>
          </Col>

          <Col lg={6}>
            <InputText
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
              title="Experience*"
            />
            <div className="err">{experienceerr} </div>
          </Col>
          <Col lg={12}>
            <div className="d-f a-c chooseFileContainer">
              <div className="resumeTxt">
                Resume* (Upload doc file, pdf, jpg less than 2 MB)
              </div>
              {/* <input type="file" /> */}

              <div className="inputContainer">
                {/* <InputText
                  chooseFile
                  text
                  borderNone
                  onChange={(e) => alert(e.target.value)}
                /> */}
                <input
                  id="uploadResume2"
                  accept="image/jpg ,application/pdf,.doc,.docx"
                  type="file"
                  onChange={(e) => setResume(e.target.files[0])}
                  name="passport_proof_upload"
                />

                <label
                  style={{ border: "none" }}
                  for="uploadResume2"
                  className="d-f"
                  id="file-drag"
                >
                  <img src={upload} className="img-fluid" />
                  <div className="chooseTxt">Choose File</div>
                </label>
              </div>
            </div>
            <div style={{ paddingTop: "0.2em" }}>{resume.name}</div>
            <div className="err">{resumeerr}</div>
          </Col>
        </Row>
        <div className="btnContainer">
          <Button onClick={submit} title="SUBMIT" />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default JobApplyModel;
